import { render, staticRenderFns } from "./ESGScopeConversionPage.vue?vue&type=template&id=65d9389a"
import script from "./ESGScopeConversionPage.vue?vue&type=script&lang=js"
export * from "./ESGScopeConversionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports